(function ($) {
  Drupal.behaviors.trendLandingPageV1 = {
    isMobile: false,
    $header: $('.js-site-header__wrapper', document),
    blogPath: '',
    attach: function (context, settings) {
      var self = this;

      self.blogPath = settings.elc_blog_menu_slug;
      var $module = $('.js-trend-landing-page', context);

      self.getDom($module, settings);
      self.getConfig($module, settings);
      self.updateSortHtml($module);
      self.setListeners($module);
    },
    getDom: function ($module, settings) {
      var self = this;

      $module.nodes = {};
      $module.nodes.container = $('.js-trend-landing-page-container', $module);
      $module.nodes.tags = $('.js-trend-landing-page-tags', $module);
      $module.nodes.sort = $('.js-trend-landing-page-sort', $module);
      $module.nodes.sortList = $('ul', $module.nodes.sort);
      $module.nodes.sortItems = $('li', $module.nodes.sortList);
      $module.nodes.filter = $('.js-trend-landing-page-filter', $module);
      $module.nodes.filterList = $('ul', $module.nodes.filter);
      $module.nodes.filterItems = $('li', $module.nodes.filterList);
      $module.nodes.tiles = $('.js-trend-landing-page-tiles', $module);
      $module.nodes.trendPost = $('.js-trend-post-tile', $module.nodes.tiles);
      $module.nodes.pagination = $('.js-trend-landing-page-pagination', $module);
      $module.nodes.next = $('.js-trend-landing-page-pagination-next', $module.nodes.pagination);
      $module.nodes.prev = $('.js-trend-landing-page-pagination-prev', $module.nodes.pagination);
      $module.nodes.$blogPagination = $('.js-blog_pagination', $module.nodes.pagination);
      if (self.isMobile) {
        $module.data('tileCountMobile') ? parseInt($module.data('tileCountMobile'), 10) : settings.elc_blog_page_size_mobile;
      }
    },
    getConfig: function ($module, settings) {
      $module.config = {};
      $module.config.isLoading = false;
      $module.config.selectedCategory = 'all';
      $module.config.selectedDirection = 'latest';
      $module.config.limit = $module.data('tileCount') ? parseInt($module.data('tileCount'), 10) : settings.elc_blog_page_size;
    },
    updateHtml: function ($item) {
      var url;
      var $radioHtml = $('<div class="radio-outer"><div class="radio-inner"></div></div>');

      if ($item.length > 0) {
        url = $item.attr('href');
        if (url) {
          $item.attr('data-sort-term', url.substring(url.lastIndexOf('/') + 1));
          $item.removeAttr('href');
          $radioHtml.insertBefore($item);
        }
      }
    },
    updateSortHtml: function ($module) {
      var self = this;
      var $filter;
      var $sort;

      $module.nodes.sortList.addClass('trend-landing-page__lists');
      $module.nodes.filterList.addClass('trend-landing-page__lists');

      $module.nodes.sortItems.each(function () {
        $sort = $(this);
        $sort.addClass('trend-landing-page__listitem');
        self.updateHtml($sort.find('a'));
      });
      $module.nodes.filterItems.each(function () {
        $filter = $(this);
        $filter.addClass('trend-landing-page__listitem');
        self.updateHtml($filter.find('a'));
      });
      $module.nodes.filterList.prepend('<li class="trend-landing-page__listitem active"><div class="radio-outer"><div class="radio-inner"></div></div><a data-sort-term="all">All</a></li>');
      $module.nodes.filterItems = $('li', $module.nodes.filterList);
      $module.nodes.tags.addClass('active');
    },
    updateLinks: function ($module, page) {
      var self = this;
      var prevPage = page - 1;
      var nextPage = page + 1;
      var prevLink = prevPage > 1 ? `/${self.blogPath}/page/${prevPage}` : `/${self.blogPath}`;
      var nextLimit = $module.nodes.$blogPagination.children().length + 1;

      $module.nodes.prev.attr('href', prevLink);
      var nextLink = `/${self.blogPath}/page/${nextPage}`;

      // The current page is not a link, so we need to increase by 1 the childrens length.
      if (nextLimit >= nextPage) {
        /**
         Make sure the next link is available under navigation.
         So we don't add links that are not available.
         */
        $module.nodes.next.attr('href', nextLink);
      }
    },

    togglePagBtns: function ($module, page = null) {
      var self = this;
      $module.nodes.prev.removeClass('hidden');
      $module.nodes.next.removeClass('hidden');
      if (!page) {
        page = self.getPageFromUrl();
      }
      if (page === 1) {
        $module.nodes.prev.addClass('hidden');
      }
    },
    postProcessing: function ($module, dataLength) {
      var self = this;
      var position;

      $module.nodes.trendPost = $('.js-trend-post-tile', $module.nodes.tiles);
      $module.nodes.container.removeClass('loading');
      $module.nodes.container.removeClass('displayoff');
      $module.config.isLoading = false;
      position = $module.nodes.tags.position().top - self.$header.outerHeight(true);
      window.scrollTo($module.position().left, position);
      if (dataLength < $module.config.limit) {
        $module.nodes.next.addClass('hidden');
      } else {
        $module.nodes.next.removeClass('hidden');
      }
    },
    processData: function ($module, data) {
      var self = this;
      var i;

      if (data.length > 0) {
        $module.nodes.tiles.html('');
        for (i = 0; i < data.length; i++) {
          $module.nodes.tiles.append($(data[i]['rendered']));
        }
      } else {
        $module.nodes.next.addClass('hidden');
      }
      self.postProcessing($module, data.length);
    },
    getBlogData: function ($module, page) {
      var self = this;
      var direction;
      var apiUrl;
      var i;
      var count = (page - 1) * $module.config.limit;
      $module.config.isLoading = true;
      $module.nodes.container.addClass('loading');
      direction = ($module.config.selectedDirection === 'latest') ? 'DESC' : 'ASC';
      apiUrl = '/elc_api/blog/' + $module.config.selectedCategory + '/all/' + $module.config.limit + '/' + count + '/' + direction;

      $.getJSON(apiUrl, function (jsonData) {
        var jsonDataArray = [];
        var sortedPosts = [];

        for (i in jsonData) {
          jsonDataArray.push(jsonData[i]);
        }
        sortedPosts = self.sortArrayOfObjects(jsonDataArray, ($module.config.selectedDirection === 'latest') ? 'descending' : 'ascending');
        self.processData($module, sortedPosts);
      });
    },
    getPageFromUrl: function () {
      var self = this;
      var urlPattern = new RegExp(`/${self.blogPath}/page/\\d+`);
      var match = window.location.pathname.match(urlPattern);
      var page = 1;

      if (match?.length > 0) {
        page = match[0].split('/')[3];
      }
      return parseInt(page);
    },

    renderNextIteration: function ($module, isNext = true) {
      var self = this;
      var page = self.getPageFromUrl();
      var nextPage = isNext ? (page + 1) : (page - 1);
      nextPage = nextPage < 1 ? 1 : nextPage;
      var nextPath = nextPage > 1 ? `/${self.blogPath}/page/${nextPage}` : `/${self.blogPath}`;

      self.updateLinks($module, nextPage);
      self.togglePagBtns($module, nextPage);
      self.getBlogData($module, nextPage);
      history.pushState({}, '', nextPath);
    },
    checkIfMobile: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['usn-medium'], 10);

      return currentBpWidth <= bPlargeUp;
    },
    setListeners: function ($module) {
      var self = this;
      var $filter;
      var $sort;

      $(document).once('trend-landing-page').on('click', function (e) {
        if ($module.nodes.filter !== e.target && !$module.nodes.filter.has(e.target).length) {
          $module.nodes.filter.removeClass('active');
        }
        if ($module.nodes.sort !== e.target && !$module.nodes.sort.has(e.target).length) {
          $module.nodes.sort.removeClass('active');
        }
      });

      $module.nodes.filter.once().on('click', function () {
        setTimeout(function () {
          $module.nodes.filter.toggleClass('active');
          if ($module.nodes.filter.hasClass('active')) {
            $module.nodes.sort.removeClass('active');
          }
        }, 50);
      });
      $module.nodes.sort.once().on('click', function () {
        setTimeout(function () {
          $module.nodes.sort.toggleClass('active');
          if ($module.nodes.sort.hasClass('active')) {
            $module.nodes.filter.removeClass('active');
          }
        }, 50);
      });

      $module.nodes.sortItems.once().on('click', function () {
        $sort = $(this);
        $module.nodes.sortItems.removeClass('active');
        $module.config.selectedDirection = $sort.find('a').data('sortTerm');
        $sort.addClass('active');
        $module.config.iteration = 0;
        history.pushState({}, '', `/${self.blogPath}`);
        self.togglePagBtns($module, 1);
        self.getBlogData($module, 1);
      });

      $module.nodes.filterItems.once().on('click', function () {
        $filter = $(this);
        $module.nodes.filterItems.removeClass('active');
        $module.config.selectedCategory = $filter.find('a').data('sortTerm');
        $filter.addClass('active');
        $module.config.iteration = 0;
        history.pushState({}, '', `/${self.blogPath}`);
        self.togglePagBtns($module, 1);
        self.getBlogData($module, 1);
      });

      $module.nodes.prev.once().on('click', function (e) {
        e.preventDefault();
        if (!$module.config.isLoading) {
          self.renderNextIteration($module, false);
        }
      });

      $module.nodes.next.once().on('click', function (e) {
        e.preventDefault();
        if (!$module.config.isLoading) {
          self.renderNextIteration($module, true);
        }
      });

      Unison.on('change', function () {
        self.isMobile = self.checkIfMobile();
        $module.config.limit = $module.data('tileCount') ? parseInt($module.data('tileCount'), 10) : 9;
        if (self.isMobile) {
          $module.config.limit = $module.data('tileCountMobile') ? parseInt($module.data('tileCountMobile'), 10) : 6;
        }
      });
    },
    sortArrayOfObjects: function (arr, order = 'ascending') {
      const sortedArr = arr.sort((a, b) => {
        if (a['publish_date_epoch'] < b['publish_date_epoch']) {
          return -1;
        }
        if (a['publish_date_epoch'] > b['publish_date_epoch']) {
          return 1;
        }

        return 0;
      });

      if (order === 'descending') {
        return sortedArr.reverse();
      }

      return sortedArr;
    }
  };
})(jQuery);
